/* ============================================================
   CHRONCES — <cr-rail>
   Carrousel horizontal réutilisable (collections, best-sellers,
   vidéos, avis…). Le défilement natif fait le travail ; le JS
   n'ajoute que les flèches desktop et leur état désactivé.
   ============================================================ */

class CrRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-cr-rail-track]');
    this.prev = this.querySelector('[data-cr-rail-prev]');
    this.next = this.querySelector('[data-cr-rail-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.scrollBy(-1));
    this.next?.addEventListener('click', () => this.scrollBy(1));
    this.track.addEventListener('scroll', this.syncArrows, { passive: true });

    // Les flèches n'ont de sens que si le contenu déborde.
    this.observer = new ResizeObserver(this.syncArrows);
    this.observer.observe(this.track);
    this.syncArrows();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  scrollBy(direction) {
    this.track.scrollBy({ left: direction * this.track.clientWidth * 0.82, behavior: 'smooth' });
  }

  syncArrows = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const overflows = scrollWidth > clientWidth + 4;
    this.classList.toggle('cr-rail-wrap--static', !overflows);
    if (this.prev) this.prev.disabled = !overflows || scrollLeft <= 2;
    if (this.next) this.next.disabled = !overflows || scrollLeft >= scrollWidth - clientWidth - 2;
  };
}

if (!customElements.get('cr-rail')) customElements.define('cr-rail', CrRail);
